export default [
  {
    name: "Övrigt",
    id: "ead531c3-372c-4dd6-9280-2c9db28ddc38",
  },
  {
    name: "SkåLand",
    id: "352c3dde-3767-4940-aa63-a4eac42449bf",
  },
  {
    name: "Ryds motionscentrum",
    id: "68f91168-7320-427b-a71a-60b0e49d4f29",
  },
  {
    name: "Konsert och Kongress",
    id: "caae84d5-f78a-4e94-9aaf-6fcf0233f0ac",
  },
  {
    name: "Vallamassivet",
    id: "6c12bc19-0be4-40c8-a6ce-461df8e227f9",
  },
  {
    name: "Stångebrofält",
    id: "38b49703-feed-4cdd-bde2-234bc63fc852",
  },
  {
    name: "Flamman",
    id: "70437e5a-932a-44cb-b718-cad203e94f50",
  },
  {
    name: "VilleValla",
    id: "851c117b-73b0-4160-abd8-2cb1f75c3dbf",
  },
  {
    name: "Ballpoint",
    id: "dd512dbb-def2-4f71-8314-30cbf718d4e3",
  },
];
